const Management = () => {
  return <div>TournamentManagement</div>;
};

export default Management;
